import * as React from "react";
import { FunctionComponent } from "react";

// A status pill in the bottom left corner, e.g. while connecting.
const FloatingPanel: FunctionComponent<{ visible: boolean }> = (props) => {
  if (props.visible === false) return <></>
  return (
    <div className="floating-panel" role="status">
      <span className="dot" />
      {props.children}
      <style jsx>{`
        .floating-panel {
          position: fixed;
          left: 16px;
          bottom: 16px;
          z-index: 100;
          display: flex;
          align-items: center;
          gap: 10px;
          min-height: 44px;
          padding: 0 18px;
          box-sizing: border-box;
          border-radius: 22px;
          background: var(--surface);
          color: var(--ink);
          font-weight: 700;
          font-size: 14px;
          box-shadow: inset 0 0 0 1px var(--line), 0 12px 30px rgba(0, 0, 0, .3);
        }
        .floating-panel .dot {
          color: var(--accent);
        }
      `}</style>
    </div>
  )
};

export default FloatingPanel;
